import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/actions/configuration/rootReducer';
import { ExternalSource } from 'src/actions/integrations/integrationSources';
import integrationsResource from 'src/actions/integrations/integrationsResource';
import lookupDebuggerBasicResource from 'src/actions/integrations/lookupAdapterDebugging/lookupDebuggerBasicResource';
import lookupDebuggerDetailedResource from 'src/actions/integrations/lookupAdapterDebugging/lookupDebuggerDetailedResource';
import useResource from 'src/presentation/hooks/useResource';
import BasicDebuggingResults from './BasicDebuggingResults';
import DetailedDebuggingResults from './DetailedDebuggingResults';
import LookupDebuggerPageLayout from './LookupDebuggingPageLayout';
import { DebugFlowType } from './SearchPanel';

const BasicLookupDebugger: FC = () => {
  const orgId = useSelector((state: RootState) => state.auth.orgId);
  const [currentApp, setCurrentApp] = useState<ExternalSource>();
  const dispatch = useDispatch();
  const workFlowTitle = 'Test Basic + Detailed Workflow';
  const { values: allIntegrations, loadingState: integrationLoadingState } = useResource(integrationsResource);

  const [enabledIntegrations, setEnabledIntegrations] = useState<ExternalSource[]>([]);

  useEffect(() => {
    const enabledIntegrations = allIntegrations.filter(
      integration => integration.enabled && integration.customerLookupSettings
    );
    setEnabledIntegrations(enabledIntegrations);
  }, [allIntegrations, dispatch]);

  const unloadResources = () => {
    dispatch(lookupDebuggerBasicResource.effects.unload());
    dispatch(lookupDebuggerDetailedResource.effects.unload());
  };

  const onSubmit = formValues => {
    dispatch(
      lookupDebuggerBasicResource.effects.fetchBasicDebugging(
        { orgId: orgId, integrationId: formValues.appId },
        {
          lookupLevel: 'BASIC',
          query: formValues.queryAttr,
        }
      )
    );
    const currentApp = enabledIntegrations.find(app => app.id === formValues.appId);
    setCurrentApp(currentApp);
  };

  return (
    <LookupDebuggerPageLayout
      onSubmit={onSubmit}
      enabledIntegrations={enabledIntegrations}
      integrationLoadingState={integrationLoadingState}
      currentApp={currentApp}
      flowType={DebugFlowType.BASIC}
      unloadResources={unloadResources}
      workFlowTitle={workFlowTitle}
    >
      <BasicDebuggingResults selectedApp={currentApp} orgId={orgId} />
      <DetailedDebuggingResults />
    </LookupDebuggerPageLayout>
  );
};

export default BasicLookupDebugger;
